module.exports = __webpack_public_path__ + "static/grung_green_bleep-2f9e35055c1a368e0b5b26ed0169558e.jpg";